import { useState, useEffect } from "react";

/**
 * Hook לזיהוי אם המכשיר הוא מובייל
 * @param breakpoint גודל מסך מינימלי לדסקטופ (default: 768px)
 * @returns true אם המכשיר קטן מה-breakpoint
 */
export const useIsMobile = (breakpoint: number = 768): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
};
